module.exports = __webpack_public_path__ + "static/ceo-9b2b7ec9b72ce97910a36ce0e7e40137.png";